export default __webpack_public_path__ + "static/media/profiili-lightblue.e1456ab6.svg";